const messages = {
  title: "Marketingové souhlasy",
  required: "Povinné",
  answered: "✓ Zodpovězeno",
  read: "Přečteno",
  notRead: "Nepřečteno",
  alreadyAnswered: "Již zodpovězeno",
  requiredQuestionsMustBeAccepted:
    "Je nutné přijmout ještě {count} povinných otázek",
  pleaseAnswerQuestions: "Odpovězte prosím na následující otázky:",
  iAccept: "Souhlasím",
  scrollToUnlock: "Pro odemčení sjeďte na konec",
  fieldRequired: "Toto pole je povinné",
  scrollToContinue: "↓ Pro pokračování sjeďte na konec",
  saving: "Ukládání...",
  saveConsents: "Uložit souhlasy",
  allRequiredAccepted: "✓ Všechny povinné otázky přijaty",
  requiredConsentsCompleted:
    "{completed}/{total} povinných souhlasů vyplněno",
  selectConsentToView:
    "Vyberte souhlas ze seznamu pro zobrazení obsahu",
  readAllContentFirst: "Nejprve si přečtěte celý obsah: {names}",
  acceptAllRequiredIn:
    "Přijměte všechny povinné otázky v: {names}",
  acceptAllBeforeSaving:
    "Před uložením přijměte všechny povinné otázky.",
  failedToSave: "Souhlasy se nepodařilo uložit. Zkuste to znovu.",
  errorSaving:
    "Při ukládání souhlasů došlo k chybě. Zkuste to znovu.",
  failedToLoad: "Souhlasy se nepodařilo načíst. Obnovte stránku.",
  viewPdf: "Zobrazit PDF",
  requiredConsentTitle: "Povinný souhlas",
  acceptAndContinue: "Přijmout a pokračovat",
};

export default {
  messages,
};
